import React from 'react';

const SidebarRight = props => {
  const { children, className } = props;
  return <div className={`sidebar-right ${className || ''}`}>{children}</div>;
};

export default SidebarRight;
